/*
  Do not edit directly
  Generated on Wed, 21 Jan 2026 14:14:17 GMT
*/
/* eslint-disable typescript-sort-keys/string-enum */
export var BreakpointNameEnum;
(function (BreakpointNameEnum) {
    BreakpointNameEnum["Xxs"] = "xxs";
    BreakpointNameEnum["Xs"] = "xs";
    BreakpointNameEnum["Sm"] = "sm";
    BreakpointNameEnum["Md"] = "md";
    BreakpointNameEnum["Lg"] = "lg";
    BreakpointNameEnum["Xl"] = "xl";
})(BreakpointNameEnum || (BreakpointNameEnum = {}));
/* eslint-enable typescript-sort-keys/string-enum */
